import React from 'react';
import whiteLogoSvg from 'src/img/livable-logo-white.svg';
export default function WhiteLogo() {
  return /*#__PURE__*/React.createElement("img", {
    src: whiteLogoSvg,
    width: "142",
    height: "18",
    alt: "Livable white logo",
    title: "Livable white logo"
  });
}